<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Panel Solicitor Details</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Panel Solicitor</mat-label>
          <mat-select placeholder="Panel Solicitor" formControlName="panelSolicitor">
            <ng-container *ngFor="let type of panelSolicitorTypes">
              <mat-option *ngIf="type" [value]="type.id">{{type.text}}</mat-option>
            </ng-container>
           </mat-select>
           <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'panelSolicitor'">
            </app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Mortgage Docs</mat-label>
          <mat-select placeholder="Mortgage Docs" formControlName="mortgageDocs">
            <mat-option *ngFor="let doc of mortgageDocTypes" [value]="doc.id">{{doc.text}}</mat-option>
           </mat-select>
           <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'mortgageDocs'">
            </app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4 text-center-vertical">
        <mat-checkbox formControlName="sendCopy">Copy to broker</mat-checkbox>
      </div>
    </div>
  </mat-card-content>
</mat-card>
